<template>
    <v-app-bar class="app-bar" flat>
      
        <v-img
          :src="require('@/assets/suuq.logo.svg')"
          alt="SUUQ Logo"
         class="logo-img"
          @click="navigateToHome"
        />
 
    </v-app-bar>
  </template>
  
  <script setup>
  import { useRouter } from "vue-router";
  
  const router = useRouter();
  
  // Navigate to the home page
  const navigateToHome = () => {
    console.log("Navigating to Home");
    router.push("/");
  };
  </script>
  
  <style scoped>
  .app-bar {
    background-color: white;
    border-bottom: 1px solid #e0e0e0;
    height: 60px;
  }
  
  .logo-container {
    display: flex;
    justify-content: center;
    height: 100%;
    padding: 10px 0;
  }
  
  .logo-img {
   
    
    cursor: pointer;

  }
  </style>